export default "__VITE_ASSET__CPm$91Nn__"